<template>
  <div id="app">
    <router-view v-wechat-title='$route.meta.title'/>
  </div>
</template>

<script>
export default {
    name: 'App',
    methods:{    
    }
};
</script>

<style lang="less">
  @import "./css/index.less";
</style>



// WEBPACK FOOTER //
// src/App.vue